import { render, staticRenderFns } from "./HalamanUtamaPenelitiKeamanan.vue?vue&type=template&id=160b0e8c&scoped=true&"
import script from "./HalamanUtamaPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./HalamanUtamaPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b0e8c",
  null
  
)

export default component.exports